"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcActionIconButton = void 0;
var react_1 = __importStar(require("react"));
var AcButton_1 = require("./AcButton");
var FaIcon_1 = require("../util/FaIcon");
var AcPopover_1 = require("../display/AcPopover");
exports.AcActionIconButton = react_1.forwardRef(function (_a, ref) {
    var _b = _a.icon, icon = _b === void 0 ? 'fas fa-exclamation-triangle' : _b, tooltip = _a.tooltip, tooltipPlacement = _a.tooltipPlacement, size = _a.size, rest = __rest(_a, ["icon", "tooltip", "tooltipPlacement", "size"]);
    var renderIconButton = function () {
        return (react_1.default.createElement(AcButton_1.AcButton, __assign({ ref: ref, variant: "link", size: "sm" }, rest),
            react_1.default.createElement(FaIcon_1.FaIcon, { icon: icon, size: size, fixedWidth: true })));
    };
    if (tooltip) {
        return (react_1.default.createElement(AcPopover_1.AcPopover, { placement: tooltipPlacement, text: tooltip, className: "d-inline-flex" }, renderIconButton()));
    }
    return renderIconButton();
});
exports.AcActionIconButton.displayName = 'AcActionIconButton';
//# sourceMappingURL=AcActionIconButton.js.map